module.exports = __webpack_public_path__ + "static/media/姿态识别.77026d49.png";